import { Pipe, PipeTransform } from "@angular/core";
import { ReportDataDefinitionDto } from "@api";

@Pipe({ name: "parseReportValue" })
export class ParseReportValuePipe implements PipeTransform {
  public transform(value: number, dataDefinition: ReportDataDefinitionDto): string {
    return `${new Intl.NumberFormat("de-DE").format(value || 0)} ${dataDefinition?.symbol || ""}`;
  }
}
